import { makeAutoObservable } from 'mobx';
import {
  Property,
  WelcomeData,
} from '@codefluegel/wowis-rest-typescript-client';

export default class WelcomeStore {
  private welcomeData: WelcomeData | undefined;

  public currentEstateId: number | undefined;

  constructor() {
    makeAutoObservable(this);
  }

  get currentEstate(): Property | undefined {
    if (this.currentEstateId && this.welcomeData) {
      return this.welcomeData.objects?.find(
        estate => estate.customerId === this.currentEstateId,
      );
    }
    return this.welcomeData?.objects?.[0];
  }

  getWelcomeData(): WelcomeData | undefined {
    return this.welcomeData;
  }

  setWelcomeData(welcomeData: WelcomeData | undefined): void {
    this.welcomeData = welcomeData;
  }

  setDocumentReadStatus(token: string) {
    if (this.welcomeData?.documents) {
      this.welcomeData.documents.some(group => {
        if (group.dokumente) {
          const doc = group.dokumente.find(d => d.token === token);
          if (doc) {
            doc.gelesen = true;
            return true;
          }
        }
        return false;
      });
    }
  }
}
